<div>
    <div class="margin-bottom-24">
        <div><h5>Copy implement setup</h5></div>
    </div>

    <div class="input-group-description" [@fadeInOut]>
        <b>Please select the customer and job site where the EXISTING implement is located</b>
    </div>
    <div class="margin-bottom-24">
        <div class="input-container">
            <label for="customer" class="label">Customer</label>
            <select id="customer" placeholder="Select Customer" [(ngModel)]="selectedCustomer" (change)="loadJobsitesForCustomer()" ngDefaultControl required>
                <option [value]="customer.Id" *ngFor="let customer of customerList">
                    {{customer.Name}}
                </option>
            </select>
        </div>
        <div class="input-container">
            <label for="jobsite" class="label">Job Site</label>
            <select id="jobsite" placeholder="Select Job Site" [(ngModel)]="selectedJobsite" (change)="loadEquipmentForJobsite()" ngDefaultControl required>
                <option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
                    {{jobsite.Name}}
                </option>
            </select>
        </div>

        <div class="margin-b--16">
            <b>Is the EXISTING implement on an equipment, or in inventory ?</b>
        </div>
        <div class="margin-bottom-24">
            <mat-radio-group [(ngModel)]="equipmentOrInventory" ngDefaultControl>
                <mat-radio-button [value]="1" >On Equipment</mat-radio-button>
                <mat-radio-button [value]="2" (click)="createInInventory()">In Inventory</mat-radio-button>
            </mat-radio-group>
        </div>

        <ng-container *ngIf="equipmentOrInventory==1">
            <div class="input-group-description" [@fadeInOut]>
                <b>How do you identify this equipment?</b>
            </div>
            <div class="input-container" [@fadeInOut]>
                <label for="equipment" class="label">Equipment</label>
                <select id="equipment" placeholder="Serial / Unit Number" [(ngModel)]="selectedEquipment" ngDefaultControl required (change)="onSelectEquipment()">
                    <option [value]="equipment.Id" *ngFor="let equipment of equipmentList">
                        {{equipment.SerialNumber}} : {{equipment.UnitNumber}}
                    </option>
                </select>
            </div>
        </ng-container>

        <div class="margin-b--16">
            <b>Select Implement(s) to be copied</b>
        </div>
        <ng-container>
            <div class="table-container mat-elevation-z8">
                <mat-table [dataSource]="dataSource">

                    <ng-container matColumnDef="selectImplement">
                        <mat-header-cell *matHeaderCellDef>Select Implement</mat-header-cell>
                        <mat-cell *matCellDef="let implement">
                            <mat-checkbox [(ngModel)]="implement.selectImplement" *ngIf="implement.status!=1"></mat-checkbox>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="implementTypeAndSerial">
                        <mat-header-cell *matHeaderCellDef>Implement Type : Serial</mat-header-cell>
                        <mat-cell *matCellDef="let implement">{{implement.implementTypeAndSerial}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="newSerialNo">
                        <mat-header-cell *matHeaderCellDef>New Serial No.</mat-header-cell>
                        <mat-cell *matCellDef="let implement"> 
                            <input id="newImplementSerialNo" type="text" placeholder="Serial#" [(ngModel)]="implement.newSerialNo" />
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="setupDate">
                        <mat-header-cell *matHeaderCellDef>Setup Date</mat-header-cell>
                        <mat-cell *matCellDef="let implement" style="display:flex;">
                            <input [matDatepicker]="picker" placeholder="Setup Date" [(ngModel)]="implement.setupDate" readonly="readonly">
                            <span title="Click to select a date" class="input-icon" (click)="picker.open()">
                                <i class="material-icons">date_range</i>
                            </span>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="implementHoursAtSetup">
                        <mat-header-cell *matHeaderCellDef>Implement Hours at Setup</mat-header-cell>
                        <mat-cell *matCellDef="let implement">
                            <input id="newImplementHours" type="text" placeholder="Implement Hours" [(ngModel)]="implement.implementHoursAtSetup" />
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="equipmentSMUAtSetup">
                        <mat-header-cell *matHeaderCellDef>Equipment SMU at Setup</mat-header-cell>
                        <mat-cell *matCellDef="let implement">
                            <input id="equipmentSMU" type="text" placeholder="Equipment SMU" [(ngModel)]="implement.equipmentSMUAtSetup" *ngIf="destEquipment>0" />
                            <span *ngIf="destEquipment<=0">N/A</span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef>Copied</mat-header-cell>
                        <mat-cell *matCellDef="let implement">
                            <i *ngIf="implement.status == 1" class="material-icons">check</i>
                            <i *ngIf="implement.status == -1" class="material-icons">close</i>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
            </div>
        </ng-container>

        <div class="button-container">
            <a  class="button button-no" (click)="onCloseClick()">
                <span class="button__text">Close</span>
            </a>
            <a class="button button--primary button-yes" (click)="onConfirmClick()">
                <span class="button__text">Copy Selected</span>
            </a>
        </div>
    </div>